import React from 'react';
import { Box } from '@mui/material';
import AddonBox from './AddonBox';
import NoDataAvailableMessage from '../../components/NoDataAvailable';

const AddonList = ({ addonData, theme }) => (
    <>
        {addonData.length === 0 ? (
            // Error Handling
            <Box marginTop="40px" display="flex" alignItems="center" justifyContent="center" height="55vh">
                <NoDataAvailableMessage />
            </Box>
        ) : (
            <Box marginTop="20px" display="grid" gridTemplateColumns="repeat(auto-fill, minmax(135px, 1fr))" gridAutoRows="350px" gap="10px" justifyItems="center" alignItems="start">
                {addonData.map((addon) => (
                    <AddonBox
                        key={addon._id}
                        _id={addon._id}
                        title={addon.device.name}
                        status={`Status: ${addon.device.status}`}
                        adultnchild={addon.adultnchild}
                        gender={addon.gender}
                        mask={addon.mask}
                    />
                ))}
            </Box>
        )}
    </>
);

export default AddonList;
